<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div class="form-group clear" cvModuleCxoneCustomSettingSection after="all" [moduleManager]="moduleManager">
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Additional_Filters">Additional Filters</p>
        <cv-reportingset-dynamic-filters-wrapper [moduleManager]="moduleManager" [reportingSetDefinitions]="['NRT Contact Activity Summary']"></cv-reportingset-dynamic-filters-wrapper>
    </div>
</ng-container>
